import { Utils } from "../utilities/Utils";

export interface IBookingAllocation {
    id: number;
    guid: string;
    bookingID: number;
    employeeID: number;
    hotelID: number;
    latestCheckIn: Date;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
}

export class BookingAllocation implements IBookingAllocation {

    constructor(data?: IBookingAllocation) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingAllocation) {
        Utils.clone(data, this);
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    bookingID: number = 0;
    employeeID: number = 0;
    hotelID: number = 0;
    latestCheckIn: Date = new Date();
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    addZero(x: string) {
        if (+x < 10) {
            x = "0" + x;
        }
        return x;
    }

    get latestCheckInTime() {
        if (this.latestCheckIn == null) { this.latestCheckIn = new Date(); }
        const hours = this.latestCheckIn.getHours().toString().length > 1 ? this.latestCheckIn.getHours() : "0" + this.latestCheckIn.getHours();
        const mins = this.latestCheckIn.getMinutes().toString().length > 1 ? this.latestCheckIn.getMinutes() : "0" + this.latestCheckIn.getMinutes();
        return hours + ":" + mins;
    }

    set latestCheckInTime(val: string) {

        const parts = val.split(":");
        const time = new Date();

        time.setHours(+parts[0]);
        time.setMinutes(+parts[1]);
        time.setSeconds(0);

        this.latestCheckIn = time;
    }
}